import { render, staticRenderFns } from "./addVehicleMake.vue?vue&type=template&id=bfce301c"
import script from "./addVehicleMake.vue?vue&type=script&lang=js"
export * from "./addVehicleMake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports